var _defs, _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#002445;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M323.939,518.229h-2.45V516.8a.809.809,0,0,0-.813-.8h-.471a.809.809,0,0,0-.814.8v1.43h-6.94V516.8a.809.809,0,0,0-.813-.8h-.471a.809.809,0,0,0-.813.8v1.43h-2.442a1.977,1.977,0,0,0-1.987,1.963v15.84A1.977,1.977,0,0,0,307.912,538h16.027a1.977,1.977,0,0,0,1.986-1.963v-15.84A1.977,1.977,0,0,0,323.939,518.229Zm.969,17.8a.965.965,0,0,1-.969.958H307.912a.965.965,0,0,1-.97-.958V523.079h17.966Z",
    transform: "translate(-303.926 -514.996)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 5.362,
    height: 5.074,
    transform: "translate(5.795 11.523)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCal);
export default __webpack_public_path__ + "static/media/icon_cal.b3d66d6478803dca34f1af51911717a4.svg";
export { ForwardRef as ReactComponent };